export default "__VITE_PUBLIC_ASSET__c58b6daa__"